<template>
  <div style="width: 700px ;">
    <a-table :columns="columns" :data-source="data" @resizeColumn="handleResizeColumn" :scroll="{ x: 1300, y: 1000 }">
      <template #headerCell="{ column }">
        <template v-if="column.key === 'name'">
          <span>
            <smile-outlined />
            Name
          </span>
        </template>
      </template>
  
      <template #bodyCell="{ column, record }">
        <template v-if="column.key === 'name'">
          <a>
            {{ record.name }}
          </a>
        </template>
        <template v-else-if="column.key === 'tags'">
          <span>
            <a-tag
              v-for="tag in record.tags"
              :key="tag"
              :color="tag === 'loser' ? 'volcano' : tag.length > 5 ? 'geekblue' : 'green'"
            >
              {{ tag.toUpperCase() }}
            </a-tag>
          </span>
        </template>
        <template v-else-if="column.key === 'action'">
          <span>
            <a>Invite 一 {{ record.name }}</a>
            <a-divider type="vertical" />
            <a>Delete</a>
            <a-divider type="vertical" />
            <a class="ant-dropdown-link">
              More actions
              <down-outlined />
            </a>
          </span>
        </template>
      </template>
    </a-table>
  </div>

  <div>
    111
    <border-outer-outlined />
  </div>
</template>
<script>
// import { SmileOutlined, DownOutlined } from '@ant-design/icons-vue';
import { defineComponent, ref } from 'vue';
const data = [{
  key: '1',
  name: 'John Brown',
  age: 32,
  address: 'New York No. 1 Lake Park',
  tags: ['nice', 'developer'],
}, {
  key: '2',
  name: 'Jim Green',
  age: 42,
  address: 'London No. 1 Lake Park',
  tags: ['loser'],
}, {
  key: '3',
  name: 'Joe Black',
  age: 32,
  address: 'Sidney No. 1 Lake Park',
  tags: ['cool', 'teacher'],
}];
export default defineComponent({
  // components: {
  //   SmileOutlined,
  //   DownOutlined,
  // },
  setup() {
    const columns = ref([{
      dataIndex: 'name',
      key: 'name',
      resizable: true,
      width: 150,
    }, {
      title: 'Age',
      dataIndex: 'age',
      key: 'age',
      resizable: true,
      width: 100,
      minWidth: 100,
      maxWidth: 200,
    }, {
      title: 'Address',
      dataIndex: 'address',
      key: 'address',
      resizable: true,
    }, {
      title: 'Tags',
      key: 'tags',
      dataIndex: 'tags',
      resizable: true,
    }, {
      title: 'Actiona',
      key: 'action',
      resizable: true,
      width: 300,
    }, {
      title: 'Action',
      key: 'action',
      resizable: true,
    }, {
      title: 'Action1',
      key: 'action',
      resizable: true,
    }, {
      title: 'Action2',
      key: 'action',
      resizable: true,
    }, {
      title: 'Action3',
      key: 'action',
      resizable: true,
    }, {
      title: 'Action4',
      key: 'action',
      resizable: true,
    }, {
      title: 'Action5',
      key: 'action',
      resizable: true,
    }
    
  ]);
    return {
      data,
      columns,
      handleResizeColumn: (w, col) => {
        col.width = w;
      },
    };
  },
});
</script>